import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import ProductTemplate from '../../../components/feature/ProductTemplate';
import { useSEO } from '../../../utils/seo';

const PlumbingPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Wholesale Plumbing Fixtures & Systems | Direct Import Bulk Plumbing Supply | Code-Compliant',
    description: 'Direct import wholesale plumbing fixtures and systems for contractors and developers. Bulk bathroom fixtures, kitchen sinks, faucets, and plumbing supplies with factory-direct pricing. Code-compliant products. Save on building materials with wholesale construction supply serving builders across Canada.',
    keywords: 'wholesale plumbing fixtures, bathroom fixtures bulk, plumbing supplies direct import, bulk construction materials supplier, direct import building materials, save on building materials, commercial plumbing wholesale',
    canonical: `${siteUrl}/products/plumbing`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: 'Plumbing Fixtures & Systems',
      description: 'Wholesale plumbing supplier offering direct import complete plumbing supply packages including fixtures, fittings, and accessories. Factory-direct pricing on bulk construction materials for residential and commercial projects.',
      category: 'Plumbing',
      brand: {
        '@type': 'Brand',
        name: 'Go Global Inc.',
      },
      offers: {
        '@type': 'AggregateOffer',
        priceCurrency: 'CAD',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Go Global Inc.',
        },
      },
    },
  });

  const productData = {
    category: 'Plumbing',
    title: 'Plumbing Fixtures & Systems',
    description: 'Complete plumbing supply packages including fixtures, fittings, and accessories for residential and commercial projects.',
    heroImage: 'https://public.readdy.ai/ai/img_res/2ce09b71a32e0ec861df724bccc319e5.jpg',
    benefits: [
      {
        icon: 'ri-price-tag-3-line',
        title: 'Bulk Pricing',
        description: 'Volume discounts on complete plumbing packages for large projects',
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Code Compliant',
        description: 'All products meet or exceed plumbing code requirements',
      },
      {
        icon: 'ri-truck-line',
        title: 'Complete Packages',
        description: 'Fixtures, fittings, and accessories delivered together',
      },
      {
        icon: 'ri-global-line',
        title: 'Global Brands',
        description: 'Access to premium plumbing manufacturers worldwide',
      },
    ],
    products: [
      {
        name: 'Bathroom Fixtures',
        description: 'Toilets, sinks, tubs, and showers for residential and commercial',
        image: 'https://readdy.ai/api/search-image?query=modern%20bathroom%20fixtures%20including%20white%20toilet%20and%20sink%20with%20contemporary%20design%20showing%20professional%20quality%20in%20clean%20bright%20bathroom&width=600&height=500&seq=plumbing-bathroom-001&orientation=portrait',
      },
      {
        name: 'Kitchen Sinks',
        description: 'Stainless steel, composite, and farmhouse sink options',
        image: 'https://readdy.ai/api/search-image?query=premium%20stainless%20steel%20kitchen%20sink%20with%20modern%20design%20and%20professional%20finish%20installed%20in%20contemporary%20kitchen%20countertop&width=600&height=500&seq=plumbing-kitchen-001&orientation=portrait',
      },
      {
        name: 'Faucets',
        description: 'Kitchen, bathroom, and commercial faucets in multiple finishes',
        image: 'https://readdy.ai/api/search-image?query=modern%20chrome%20bathroom%20faucet%20with%20contemporary%20design%20showing%20premium%20quality%20and%20professional%20finish%20on%20white%20sink&width=600&height=500&seq=plumbing-faucet-001&orientation=portrait',
      },
      {
        name: 'Shower Systems',
        description: 'Complete shower valves, heads, and body spray systems',
        image: 'https://readdy.ai/api/search-image?query=luxury%20shower%20system%20with%20rain%20head%20and%20hand%20shower%20in%20chrome%20finish%20installed%20in%20modern%20bathroom%20with%20tile%20walls&width=600&height=500&seq=plumbing-shower-001&orientation=portrait',
      },
      {
        name: 'Water Heaters',
        description: 'Tankless and traditional water heating systems',
        image: 'https://readdy.ai/api/search-image?query=modern%20tankless%20water%20heater%20unit%20mounted%20on%20wall%20showing%20compact%20design%20and%20professional%20installation%20in%20mechanical%20room&width=600&height=500&seq=plumbing-heater-001&orientation=portrait',
      },
      {
        name: 'Pipe & Fittings',
        description: 'PEX, copper, and PVC piping systems with fittings',
        image: 'https://readdy.ai/api/search-image?query=plumbing%20pipes%20and%20fittings%20including%20PEX%20and%20copper%20materials%20with%20professional%20connectors%20displayed%20showing%20quality%20construction%20materials&width=600&height=500&seq=plumbing-pipe-001&orientation=portrait',
      },
    ],
    specifications: [
      'WaterSense certified fixtures available',
      'ADA-compliant options for accessibility',
      'Multiple finish options: chrome, bronze, nickel, black',
      'Commercial-grade fixtures for high-traffic areas',
      'Low-flow and water-saving options',
      'Warranty programs for commercial applications',
    ],
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <ProductTemplate data={productData} />
      <Footer />
    </div>
  );
};

export default PlumbingPage;